import { createReducer } from '@reduxjs/toolkit';

export default createReducer({
  items: window.inbox?.fields?.customFields || [],
}, () => { });
